module.exports = {"pathContext":{"name":"CreateCareTeamRoleInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"locationIds","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID"}}}}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-create-care-team-role-input.json
// module id = 1397
// module chunks = 210351531541352